export {default as dispatch} from "./src/dispatch";



//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/d3-dispatch/index.js
// module id = ../../../../d3-dispatch/index.js
// module chunks = 4